var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BModal",
    {
      staticClass: "employee-bulk-upload",
      attrs: { active: "" },
      on: { close: _vm.closeModal }
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title has-text-primary" }, [
          _vm._v("\n      Estatus de carga masiva\n    ")
        ])
      ]),
      _c(
        "div",
        { staticClass: "table-container" },
        [
          _c("BTable", {
            attrs: {
              data: _vm.$store.state.employees.list,
              columns: _vm.columns
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "BTableColumn",
                      {
                        attrs: { field: "name", label: "Nombre", internal: "" }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(props.row.name) + "\n        "
                        )
                      ]
                    ),
                    _c(
                      "BTableColumn",
                      {
                        attrs: { field: "email", label: "Email", internal: "" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(props.row.email) +
                            "\n        "
                        )
                      ]
                    ),
                    _c(
                      "BTableColumn",
                      {
                        attrs: {
                          field: "message",
                          label: "message",
                          internal: ""
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(props.row.message) +
                            "\n        "
                        )
                      ]
                    ),
                    _c(
                      "BTableColumn",
                      {
                        attrs: {
                          field: "status",
                          label: "status",
                          internal: ""
                        }
                      },
                      [
                        props.row.success == false
                          ? _c("BIcon", {
                              staticClass:
                                "has-background-gray has-text-danger is-tooltip-left",
                              attrs: { icon: "close" }
                            })
                          : _vm._e(),
                        props.row.success == true
                          ? _c("BIcon", {
                              staticClass:
                                "has-background-gray has-text-success is-tooltip-left",
                              attrs: { icon: "check" }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c("footer", { staticClass: "modal-card-foot" }, [
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.closeModal } },
              [_vm._v("\n        Cerrar\n      ")]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }